'use client';

import { c as _c } from "react/compiler-runtime";
import { CommentItem } from './CommentItem';
import type { Activity } from '@/lib/api/types';
interface CommentListProps {
  comments: Activity[];
  currentUserId?: string;
  onDelete: (activityId: string) => Promise<void>;
  isLoading?: boolean;
}
export function CommentList(t0) {
  const $ = _c(11);
  const {
    comments,
    currentUserId,
    onDelete,
    isLoading
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="space-y-4">{[1, 2, 3].map(_temp)}</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (comments.length === 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="text-center py-8"><p className="text-gray-500 text-sm">No comments yet. Be the first to comment!</p></div>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== comments || $[3] !== currentUserId || $[4] !== onDelete) {
    let t2;
    if ($[6] !== currentUserId || $[7] !== onDelete) {
      t2 = comment => <CommentItem key={comment.id} comment={comment} currentUserId={currentUserId} onDelete={onDelete} />;
      $[6] = currentUserId;
      $[7] = onDelete;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = comments.map(t2);
    $[2] = comments;
    $[3] = currentUserId;
    $[4] = onDelete;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="space-y-2">{t1}</div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
function _temp(i) {
  return <div key={i} className="animate-pulse"><div className="flex gap-3 p-4"><div className="w-10 h-10 rounded-full bg-gray-200" /><div className="flex-1 space-y-2"><div className="h-4 bg-gray-200 rounded w-1/4" /><div className="h-4 bg-gray-200 rounded w-3/4" /></div></div></div>;
}